import { type Options } from 'react-use-websocket';

import { makeMessage } from './helpers';
import { MessageAction, MessageType } from './types';

export const HEARTBEAT_INTERVAL_MS = 20_000;

export const INIT_WS_OPTIONS: Options = {
  share: true,
  heartbeat: {
    message: makeMessage(MessageType.HEARTBEAT, MessageAction.EXECUTE),
    interval: HEARTBEAT_INTERVAL_MS,
  },
};
